/**
 * Price drivers (ADR 0041): the questions that move a job's price, their answer chips, "I don't know", and what an
 * estimate says about itself (how sure it is, what it rests on, what drives its spread, what was assumed).
 */
export const drivers = {
    "question.surface": "Inside walls, outside walls, or both?",
    "question.floors": "How many floors?",
    "question.house_type": "Is it a flat, an independent house or a villa?",
    "question.finish": "Plain paint, or a texture finish?",
    "question.days_week": "How many days a week?",
    "question.tasks": "Which work: sweeping and mopping, with dishes, or the full house?",
    "question.vehicle": "Which car: a hatchback, a sedan or an SUV?",
    "question.points": "How many points (switches, taps, doors or units)?",
    "detail.surface": "walls",
    "detail.floors": "floors",
    "detail.house_type": "kind of home",
    "detail.finish": "finish",
    "detail.days_week": "days a week",
    "detail.tasks": "tasks",
    "detail.vehicle": "car",
    "detail.points": "points",
    "driver.ask.area_sqft": "Roughly how many square feet is the home?",
    "driver.ask.rooms": "How many bedrooms (BHK)?",
    "driver.ask.surface": "Inside walls, outside walls, or both?",
    "driver.ask.floors": "How many floors?",
    "driver.ask.house_type": "Is it a flat, an independent house or a villa?",
    "driver.ask.paint_by": "Will you buy the paint, or should the painter bring it?",
    "driver.ask.finish": "Plain paint, or a texture finish?",
    "driver.ask.people": "How many people are there to cook for?",
    "driver.ask.meals": "How many meals a day?",
    "driver.ask.days_week": "How many days a week?",
    "driver.ask.frequency": "How often should they come?",
    "driver.ask.tasks": "Which work: sweeping and mopping, with dishes, or the full house?",
    "driver.ask.hours": "How many hours a day?",
    "driver.ask.vehicle": "Which car: a hatchback, a sedan or an SUV?",
    "driver.ask.problem": "What is the job?",
    "driver.ask.points": "How many points (switches, taps, doors or units)?",
    "driver.ask.points.electrician": "How many switches, sockets or fittings?",
    "driver.ask.points.plumber": "How many taps, pipes or fixtures?",
    "driver.ask.points.carpenter": "How many pieces, doors or fittings?",
    "driver.ask.points.ac_technician": "How many AC units?",
    "driver.value.surface.inside": "Inside",
    "driver.value.surface.outside": "Outside",
    "driver.value.surface.both": "Both",
    "driver.value.house_type.flat": "Flat",
    "driver.value.house_type.independent": "Independent house",
    "driver.value.house_type.villa": "Villa",
    "driver.value.paint_by.household": "I'll buy it",
    "driver.value.paint_by.worker": "Painter brings it",
    "driver.value.finish.plain": "Plain",
    "driver.value.finish.texture": "Texture",
    "driver.value.frequency.daily": "Every day",
    "driver.value.frequency.alternate_days": "Every other day",
    "driver.value.frequency.weekly": "Once a week",
    "driver.value.tasks.sweep_mop": "Sweeping and mopping",
    "driver.value.tasks.sweep_mop_dishes": "With dishes",
    "driver.value.tasks.full": "Full house",
    "driver.value.vehicle.hatchback": "Hatchback",
    "driver.value.vehicle.sedan": "Sedan",
    "driver.value.vehicle.suv": "SUV",
    "driver.value.problem.fan": "A fan",
    "driver.value.problem.switch": "A switch",
    "driver.value.problem.light": "A light",
    "driver.value.problem.wiring": "Wiring",
    "driver.value.problem.leak": "A leak",
    "driver.value.problem.tap": "A tap",
    "driver.value.problem.blockage": "A blockage",
    "driver.value.problem.toilet": "A toilet",
    "driver.value.problem.door": "A door",
    "driver.value.problem.repair": "A repair",
    "driver.value.problem.assembly": "Assembling furniture",
    "driver.value.problem.service": "A service",
    "driver.value.problem.gas_refill": "A gas refill",
    "driver.value.problem.install": "Installing one",
    "driver.value.problem.other": "Something else",
    "driver.n.area_sqft": "{count} sq ft",
    "driver.n.rooms.one": "{count} bedroom",
    "driver.n.rooms.other": "{count} bedrooms",
    "driver.n.floors.one": "{count} floor",
    "driver.n.floors.other": "{count} floors",
    "driver.n.people.one": "{count} person",
    "driver.n.people.other": "{count} people",
    "driver.n.meals.one": "{count} meal",
    "driver.n.meals.other": "{count} meals",
    "driver.n.days_week.one": "{count} day",
    "driver.n.days_week.other": "{count} days",
    "driver.n.hours.one": "{count} hour",
    "driver.n.hours.other": "{count} hours",
    "driver.n.points.one": "{count} point",
    "driver.n.points.other": "{count} points",
    "driver.thinking": "One moment, thinking about what to ask…",
    "driver.dont_know": "I don't know",
    "driver.noun.area_sqft": "the floor area",
    "driver.noun.rooms": "how many bedrooms",
    "driver.noun.surface": "outside walls",
    "driver.noun.floors": "how many floors",
    "driver.noun.house_type": "the kind of home",
    "driver.noun.paint_by": "who buys the paint",
    "driver.noun.finish": "the finish",
    "driver.noun.people": "how many people",
    "driver.noun.meals": "how many meals",
    "driver.noun.days_week": "days a week",
    "driver.noun.frequency": "how often",
    "driver.noun.tasks": "which tasks",
    "driver.noun.hours": "hours a day",
    "driver.noun.vehicle": "the car",
    "driver.noun.problem": "what the job is",
    "driver.noun.points": "how many points",
    "driver.confidence.high": "fairly sure",
    "driver.confidence.medium": "a rough guide",
    "driver.confidence.low": "a very rough guide",
    "driver.confidence_line": "How sure: {level}.",
    "driver.spread": "It mostly depends on {driver}.",
    "driver.assumed": "Assumed, since not known: {drivers}.",
    "driver.basis.gigsync.one": "{count} GigSync job",
    "driver.basis.gigsync.other": "{count} GigSync jobs",
    "driver.basis.rate_card": "{city} rate card: {sources}",
    "driver.basis_line": "From {parts}.",
    "driver.no_trade": "GigSync has no prices for {job} yet, and nobody offers this work on GigSync.",
};
//# sourceMappingURL=drivers.js.map